import { EXPLORA_ROUTES } from 'app/explora-routes';
import { useExploraState } from 'app/store/explora-context';
import React from 'react';
import { useHistory } from 'react-router-dom';
import PrimaryButton from 'shared/components/PrimaryButton/PrimaryButton';
import SocialMedia from 'shared/components/SocialMedia/SocialMedia';
import TextBody from 'shared/components/TextBody/TextBody';
import TextHeadline from 'shared/components/TextHeadline/TextHeadline';
import WithBackground from 'shared/hoc/WithBackground';
import { FontColor, FontSize } from 'shared/styles/typography';
import './Landing.scss';

const Landing = () => {
  const history = useHistory();
  const { homeContent } = useExploraState();
  const { landing } = homeContent;

  return (
    <WithBackground imageName="home">
      <SocialMedia />
      <section className="landing-container">
        {landing.title.map((word) => (
          <TextHeadline bold key={word} component="p" color={FontColor.PrimaryMain} size={FontSize.Large}>
            {word}
          </TextHeadline>
        ))}
      </section>
      <section className="landing-container">
        {landing.subtitle.map((word) => (
          <TextHeadline key={word} component="p" color={FontColor.PrimaryMain} size={FontSize.Medium}>
            {word}
          </TextHeadline>
        ))}
      </section>
      <section className="landing-container">
        <PrimaryButton
          backgroundColor={FontColor.PrimaryLight}
          onClick={() => history.push(EXPLORA_ROUTES.Contact)}
          style={{ margin: '0 1rem 1rem 0' }}
        >
          <TextBody component="span" size={FontSize.Medium}>
            Contáctanos
          </TextBody>
        </PrimaryButton>
        <PrimaryButton
          textColor={FontColor.SecondaryMain}
          backgroundColor={FontColor.PrimaryLight}
          onClick={() => history.push(EXPLORA_ROUTES.Blog)}
        >
          <TextBody component="span" size={FontSize.Medium}>
            Blog Explora
          </TextBody>
        </PrimaryButton>
      </section>
    </WithBackground>
  );
};

export default Landing;
